export class NoPermission { }
